import { PermissionChecker } from '@socrates/common';

export abstract class IPermissionsRepo {
	abstract getPermissions(env: string): Promise<PermissionChecker>;
}
